import { useEffect, useState } from "react";
import ScrollableList from "../../../../../Components/ScrollableList/ScrollableList";
import PlayerInGameRoles from "../../../../../Services/Api/PlayerInGameRoles.ts";
import InGameRoles from "../../../../../Services/Api/InGameRoles.ts";
import InGameRolesList from "./Components/InGameRolesList/InGameRolesList.js";
import { IoIosSettings } from "react-icons/io";
import { MdEdit } from "react-icons/md";
import AddEditPlayerRole from "./Components/AddEditPlayerRole/AddEditPlayerRole.js";

const UserInGameRoles = ({groupId}) => {
    const playerInGameRoles = new PlayerInGameRoles();
    const inGameRoles = new InGameRoles();

    const [showAddEdit, setShowAddEdit] = useState(false);
    const [groupUserRoles, setGroupUserRoles] = useState(null);
    const [roles, setRoles] = useState(null);
    const [showRolesList, setShowRolesList] = useState(false);

    const [editData, setEditData] = useState({});

    useEffect(() => {
        refresh();
    }, [groupId]);

    const getExpiresDateStyle = (inGameRole) => {
        if(inGameRole.shouldExpire){
            const roleDate = new Date(inGameRole.expires);

            const expired = roleDate < new Date();
    
            return expired ? <span className="text-glred">{inGameRole.expires.split("T")[0]} (Wygasła)</span> : <>{inGameRole.expires.split("T")[0]}</>
        }else {
            return <>Nigdy</>
        }
    }

    const processData = (data, roles) => {
        const mapedData = data.map((roleData) => {
            const role = roles.find(x => x.id == roleData.playerInGameRole.inGameRoleId);
            
            return {
                img: {
                    src: roleData.steamPlayer?.avatarfull,
                    className: "h-32 w-32 rounded-sm"
                },
                id: roleData.playerInGameRole.id,
                columns: [
                    <p><span className="text-glwhite-600">Nick:</span> {roleData.steamPlayer?.personaname}</p>,
                    <p><span className="text-glwhite-600">Id w grze:</span> {roleData.playerInGameRole.userId}</p>, 
                    <p><span className="text-glwhite-600">Id Discord:</span> {roleData.playerInGameRole.discordId}</p>, 
                    <p><span className="text-glwhite-600">Wygasa:</span> {getExpiresDateStyle(roleData.playerInGameRole)}</p>,
                    <p><span className="text-glwhite-600">Rola:</span> {role.roleName}</p>
                ],
                text: [
                    roleData.steamPlayer?.personaname,
                    roleData.playerInGameRole.userId, 
                    roleData.playerInGameRole.discordId, 
                    roleData.playerInGameRole.shouldExpire ? roleData.playerInGameRole.expires.split("T")[0] : "Nigdy",
                    role.roleName
                ],
                // serverId : groupServer.serverObject.id,
        }})

        setGroupUserRoles({processedData: mapedData, data: data})
    };

    const refresh = () => {
        inGameRoles.GetAll((data) => {
            setRoles(data);
            playerInGameRoles.GetForGroup(groupId, (playerRoles) => processData(playerRoles, data));
        });  
    }

    const removeFunction = (id) => {
        playerInGameRoles.Delete(id, () => {
            refresh()
        });
    }

    const edit = (data) => {
        const toEdit = groupUserRoles.data.find(x => x.playerInGameRole.id == data);
        if(toEdit){
            setEditData(toEdit.playerInGameRole);
            setShowAddEdit(true);
        }
    }

    if(!groupUserRoles)
        return (<div className="text-center">Ładowanie danych...</div>);

    return (
        <>
            <div className="flex flex-row-reverse mb-3">
                <button onClick={() => setShowRolesList(true)}>
                    <IoIosSettings />
                    Zarządzaj rolami
                </button>
            </div>
            { showRolesList &&
                <InGameRolesList groupId={groupId} setShowRolesList={setShowRolesList}/>
            }    
            { showAddEdit &&
                <AddEditPlayerRole refresh={refresh} setShowAddEdit={setShowAddEdit} editData={editData} roles={roles} groupId={groupId}/>
            }      
            <ScrollableList 
                setShowAdd={(bool) => {setEditData(null); setShowAddEdit(bool)}}
                removeFunction={removeFunction}
                refresh={() => refresh()}
                customButtons={[
                    { icon: <MdEdit size={"22px"} className="iconBtn"/>, onClick: (data) => {edit(data.id)} }
                ]}
                title={"Role graczy"}
                data={groupUserRoles.processedData}
                listClass={"overflow-y-auto overflow-x-hidden max-h-[51vh]"}
                removeTitle={"Usuń rolę użytkownika"}
            />        
        </>
    )
}

export default UserInGameRoles;